<template>
    <div style="position: relative;">
      <custom-animation :data="animationData" class="loading" speed="1" custom="top: 45%; left: 48%;"></custom-animation>
    </div>
  </template>
  
  <script>

  import CustomAnimation from '../CustomAnimationWithLottieWithModal';
  import dwsLoading from './dwsLoading.json';
  
  export default {
    components: {
      CustomAnimation
    },
    data() {
      return {
        animationData: dwsLoading
      }
    }
  };
  </script>
  
  <style lang="scss" scoped>
  .loading {
    transform: scale(2);
    
  }

  </style>
  